import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";
import { ISrp22ConfigService } from "./ISrp22ConfigService";

export class Srp22ConfigService extends BlindConfigService implements ISrp22ConfigService {
    public static readonly ServiceName: string = "Srp22ConfigService";

    constructor() {
        super();
    }

    GetServiceName(): string {
        return Srp22ConfigService.ServiceName;
    }
}